const TYPE_OFFICE = 'OFFICE',
  TYPE_CITY = 'CITY',
  TYPE_AIRPORT = 'AIRPORT',
  ADDRESS_TYPE_CITY = 'CITY',
  ADDRESS_TYPE_AIRPORT = 'AIRPORT',
  ADDRESS_TYPE_ADDRESS = 'ADDRESS'

export { getAddressType, TYPE_OFFICE, TYPE_CITY, TYPE_AIRPORT }

function getAddressType(destinationType){
  switch (destinationType) {
    case TYPE_AIRPORT:
      return ADDRESS_TYPE_AIRPORT
    case TYPE_CITY:
      return ADDRESS_TYPE_CITY
    case TYPE_OFFICE:
    default:
      return ADDRESS_TYPE_ADDRESS
  }
}
